
import snackbarReducer from './snackbarReducer';
import { combineReducers } from 'redux';

export const Reducers = combineReducers({
    snackbarState: snackbarReducer
});